// src/components/layout/menus/OverviewMenu.jsx

import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function OverviewMenu(props) {
  return (
    <Dropdown
      menuKey="overview"
      menu={projectMenus.overview}
      {...props}
    />
  );
}
